import type React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import type { ColorScheme } from '@/components/ui/system/props';
import { cn } from '@/lib/utils';

const trackColorByScheme: Record<ColorScheme, string> = {
  primary: 'bg-primary/10',
  secondary: 'bg-secondary/20',
  neutral: 'bg-muted',
  destructive: 'bg-destructive/15',
  success: 'bg-green-500/15',
  warning: 'bg-amber-500/15',
  error: 'bg-destructive/15',
};

const indicatorColorByScheme: Record<ColorScheme, string> = {
  primary: 'bg-primary',
  secondary: 'bg-secondary-foreground',
  neutral: 'bg-muted-foreground',
  destructive: 'bg-destructive',
  success: 'bg-green-500',
  warning: 'bg-amber-500',
  error: 'bg-destructive',
};

function Progress({
  className,
  value,
  colorScheme = 'primary',
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & { colorScheme?: ColorScheme }) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value}
      className={cn(
        'relative h-1.5 w-full overflow-hidden rounded-full',
        trackColorByScheme[colorScheme],
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn('h-full w-full flex-1 transition-all', indicatorColorByScheme[colorScheme])}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
